import type { TeamRole } from '@mockd/shared';

interface RoleBadgeProps {
  role: TeamRole;
}

const roleBadgeClass: Record<TeamRole, string> = {
  owner: 'badge-primary',
  admin: 'badge-secondary',
  member: 'badge-ghost',
  viewer: 'badge-ghost',
};

export function RoleBadge({ role }: RoleBadgeProps) {
  return (
    <span className={`badge badge-sm ${roleBadgeClass[role]}`}>
      {role.charAt(0).toUpperCase() + role.slice(1)}
    </span>
  );
}
